import { actionCreatorFactory } from 'typescript-fsa';
import asyncFactory from 'typescript-fsa-redux-thunk';
import { Order } from '@pegasus/types/order';
import { OrderReturnResponse, OrderReturnRequest } from '@pegasus/types/session';
import { NAMESPACE } from './constants';
import { ReturnReasonList } from '../types';
import {
    fetchOrder,
    fetchOrderReturnSession,
    updateOrderReturnSession,
    OrderResponse,
} from '../../service';

export interface State {
    list: ReturnReasonList;
    order?: Order;
    session?: OrderReturnResponse;
    isLoading: boolean;
    isUpdateLoading: boolean;
}

type GlobalState = { [key in string]: { [key in string]: State } };

const createAction = actionCreatorFactory(NAMESPACE);
const createAsyncAction = asyncFactory<GlobalState>(createAction);

export const fetchOrderAndSession = createAsyncAction<
    { orderNumber: string; pageName: string },
    { order: OrderResponse; session: OrderReturnResponse }
>('FETCH_ORDER_AND_SESSION', async params => {
    const [order, session] = await Promise.all([
        fetchOrder(params.orderNumber),
        fetchOrderReturnSession(params.orderNumber, params.pageName),
    ]);
    return {
        order,
        session,
    };
});

export const updateSession = createAsyncAction<
    { orderNumber: string; patch: OrderReturnRequest },
    { session: OrderReturnResponse }
>('UPDATE_SESSION', async params => {
    const session = await updateOrderReturnSession(params.orderNumber, params.patch);
    return { session };
});

export const toggleItem = createAction<{ itemId: string }>('TOGGLE_ITEM');

export const selectReason = createAction<{ itemId: string; reason: string | undefined }>(
    'SELECT_REASON',
);

export const markItemsInvalid = createAction('MARK_INVALID_ITEMS');

export const markItemsValid = createAction('MARK_VALID_ITEMS');
